import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import style from "./style.module.scss";
import { OnBoardTeam } from "./OnBoardTeam";
import { OperationContext } from "../CreateOperation";
import { DatePicker, Form } from "antd";
import { FormProvider } from "../../../../../common/provider/form/Form.provider";
import { SimpleInput } from "../../../../../common/components/simpleInput";
import TextArea from "antd/es/input/TextArea";
import { PlanningService } from "../../../core/_request";
import Spinner from "../../../../../common/components/Spinner/Spinner";
import { PlanningConstant } from "../../../core/_constant";
import { HttpStatusCode } from "axios";
import dayjs from "dayjs";
import { useOperationType } from "../../../core/_context";

export const PlanningContext = createContext<any>({});

const defaultErrorMessageValue = {
  [PlanningConstant.TEAM_ON_BOARD_ID]: [],
  [PlanningConstant.TEAM_DOCKSIDE_ID]: [],
  [PlanningConstant.TEAM_STORAGE_ID]: [],
};

export const PlanningForm = () => {
  const {
    initialValue,
    handleSetOperationDefaultData,
    filter,
    setFilter,
    refreshData,
  } = useContext(OperationContext);
  const [form] = Form.useForm();
  const buttonSubmitRef = useRef<HTMLButtonElement>(null);

  const operationType = useOperationType();

  const [errorMessage, setErrorMessage] = useState<any>(
    defaultErrorMessageValue
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isDisableForm, setIsDisableForm] = useState<boolean>(false);
  // const [isOpenMaterialDrawer, setIsOpenMaterialDrawer] =
  //   useState<boolean>(false);
  const [allState, setAllState] = useState<any>({
    teams: [],
    teamsDockside: [],
    teamsStorage: [],
  });

  useEffect(() => {
    refreshData();
    setFilter((prev: any) => ({
      ...prev,
      teamsCreatedAt: dayjs().format("YYYY-MM-DD"),
    }));
  }, []);

  useEffect(() => {
    setErrorMessage(defaultErrorMessageValue);
  }, [allState]);

  useEffect(() => {
    if (filter && filter?.teamsCreatedAt) {
      const isFilterDateIsNow = dayjs(filter?.teamsCreatedAt).isSame(
        dayjs(),
        "date"
      );
      setIsDisableForm(!isFilterDateIsNow);
    }
  }, [filter]);

  useEffect(() => {
    form?.setFieldValue("noteTeam", initialValue?.noteTeam);
    setAllState((prev: any) => ({
      ...prev,
      noteTeam: initialValue?.noteTeam,
      teams: initialValue?.teamsOnBoard?.map((item: any) => ({
        ...item,
        holds: item?.holds?.map((h: number) => ({
          label: h,
          value: h,
        })),
        modelTeamStaff: item?.teamStaff?.map((staff: any) => ({
          ...staff,
          name: staff?.staffPost?.name,
        })),
        teamType: item?.teamType?.["@id"],
      })),

      teamsDockside: initialValue?.teamsDockside?.map((item: any) => ({
        ...item,
        holds: item?.holds?.map((h: number) => ({
          label: h,
          value: h,
        })),
        modelTeamStaff: item?.teamStaff?.map((staff: any) => ({
          ...staff,
          name: staff?.staffPost?.name,
        })),
        teamType: item?.teamType?.["@id"],
      })),
      teamsStorage: initialValue?.teamsStorage?.map((item: any) => ({
        ...item,
        holds: item?.holds?.map((h: number) => ({
          label: h,
          value: h,
        })),
        modelTeamStaff: item?.teamStaff?.map((staff: any) => ({
          ...staff,
          name: staff?.staffPost?.name,
        })),
        teamType: item?.teamType?.["@id"],
      })),
    }));
  }, [initialValue]);

  const getKeyName = (teamKey: string) => {
    let key;
    switch (teamKey) {
      case PlanningConstant.TEAM_ON_BOARD_ID:
        key = "teams";
        break;
      case PlanningConstant.TEAM_DOCKSIDE_ID:
        key = "teamsDockside";
        break;
      case PlanningConstant.TEAM_STORAGE_ID:
        key = "teamsStorage";
        break;
      default:
        key = "teams";
    }
    return key;
  };

  const handleSetTeamValue = (value: any, teamKey: string) => {
    const { index, ...rest } = value;

    const keyName = getKeyName(teamKey);

    if (index || index === 0) {
      setAllState((prev: any) => ({
        ...prev,
        [keyName]: prev?.[keyName]?.map((item: any, key: number) => {
          if (key !== index) {
            return item;
          } else {
            return { ...item, ...rest, teamType: teamKey };
          }
        }),
      }));
    } else {
      setAllState((prev: any) => ({
        ...prev,
        [keyName]: [...prev?.[keyName], { ...rest, teamType: teamKey }],
      }));
    }
  };

  const handleDeleteTeamValue = (index: number, teamKey: string) => {
    const keyName = onGetKeyName(teamKey);
      // teamKey === PlanningConstant.TEAM_ON_BOARD_ID ? "teams" : "teamsDockside";

    setAllState((prev: any) => ({
      ...prev,
      [keyName]: prev?.[keyName]?.filter(
        (_: any, key: number) => key !== index
      ),
    }));
  };

  const onChangeHoldsHandler = (values: any, teamKey: string) => {
    const { key, value } = values;
    const keyName = onGetKeyName(teamKey);
      // teamKey === PlanningConstant.TEAM_ON_BOARD_ID ? "teams" : "teamsDockside";

    setAllState((prev: any) => ({
      ...prev,
      [keyName]: prev?.[keyName]?.map((item: any, index: number) => {
        if (index !== key) {
          return item;
        } else {
          return {
            ...item,
            holds: value,
          };
        }
      }),
    }));
  };
  const onChangeInput = (values: any, teamKey: string) => {
    const { key, value } = values;
    const keyName = onGetKeyName(teamKey);
    // teamKey === PlanningConstant.TEAM_ON_BOARD_ID ? "teams" : "teamsDockside";

    setAllState((prev: any) => ({
      ...prev,
      [keyName]: prev?.[keyName]?.map((item: any, index: number) => {
        if (index !== key) {
          return item;
        } else {
          return {
            ...item,
            ...value,
          };
        }
      }),
    }));
  };

  const onGetKeyName = (key: string) => {
    switch (key) {
      case PlanningConstant.TEAM_ON_BOARD_ID:
        return "teams";

      case PlanningConstant.TEAM_DOCKSIDE_ID:
        return "teamsDockside";

      case PlanningConstant.TEAM_STORAGE_ID:
        return "teamsStorage";
      default:
        return "_";
    }
  };

  const onChangeTimeLine = (values: any, teamKey: string) => {
    const { key, value } = values;
    const keyName = onGetKeyName(teamKey);
    // teamKey === PlanningConstant.TEAM_ON_BOARD_ID ? "teams" : "teamsDockside";

    setAllState((prev: any) => ({
      ...prev,
      [keyName]: prev?.[keyName]?.map((item: any, index: number) => {
        if (index !== key) {
          return item;
        } else {
          return {
            ...item,
            ...value,
          };
        }
      }),
    }));
  };

  const handleClickOnSave = async (values: any) => {
    // setErrorMessage([]);

    try {
      setIsLoading(true);
      const dataToPost = {
        id: initialValue?.id,
        "@id": initialValue?.["@id"],
        ...values,
        ...allState,
        noteTeam: values?.noteTeam,
        teams: [
          ...allState?.teams?.map((item: any) => ({
            ...(item?.["@id"]?.includes("model_teams")
              ? {}
              : {
                  "@id": item?.["@id"],
                }),
            name: item?.name,
            teamType: item?.teamType,
            holds: item?.holds
              ? item?.holds?.map((hol: any) => hol?.value)
              : [],
            teamShiftStart: dayjs(item?.teamShiftStart).format("HH:mm"),
            teamShiftEnd: dayjs(item?.teamShiftEnd).format("HH:mm"),
            teamStaff: item?.modelTeamStaff?.map((team: any) => ({
              "@id": team?.["@id"],
              staffPost: team?.staffPost?.["@id"],
              staff: team?.staff?.map((staf: any) => staf?.[`@id`]),
            })),

            ...(item?.assignmentLocation
              ? {
                  assignmentLocation: item?.assignmentLocation?.value
                    ? item?.assignmentLocation?.value
                    : item?.assignmentLocation,
                }
              : {}),
          })),
          //DockSide
          ...allState?.teamsDockside?.map((item: any) => ({
            ...(item?.["@id"]?.includes("model_teams")
              ? {}
              : {
                  "@id": item?.["@id"],
                }),
            name: item?.name,
            teamType: item?.teamType,
            holds: item?.holds
              ? item?.holds?.map((hol: any) => hol?.value)
              : [],
            teamShiftStart: dayjs(item?.teamShiftStart).format("HH:mm"),
            teamShiftEnd: dayjs(item?.teamShiftEnd).format("HH:mm"),

            teamStaff: item?.modelTeamStaff?.map((team: any) => ({
              "@id": team?.["@id"],
              staffPost: team?.staffPost?.["@id"],
              staff: team?.staff?.map((staf: any) => staf?.[`@id`]),
            })),

            ...(item?.assignmentLocation
              ? {
                  assignmentLocation: item?.assignmentLocation?.value
                    ? item?.assignmentLocation?.value
                    : item?.assignmentLocation,
                }
              : {}),
          })),
          ...allState?.teamsStorage?.map((item: any) => ({
            ...(item?.["@id"]?.includes("model_teams")
              ? {}
              : {
                  "@id": item?.["@id"],
                }),
            name: item?.name,
            teamType: item?.teamType,
            holds: item?.holds
              ? item?.holds?.map((hol: any) => hol?.value)
              : [],
            teamShiftStart: dayjs(item?.teamShiftStart).format("HH:mm"),
            teamShiftEnd: dayjs(item?.teamShiftEnd).format("HH:mm"),

            teamStaff: item?.modelTeamStaff?.map((team: any) => ({
              "@id": team?.["@id"],
              staffPost: team?.staffPost?.["@id"],
              staff: team?.staff?.map((staf: any) => staf?.[`@id`]),
            })),

            ...(item?.assignmentLocation
              ? {
                  assignmentLocation: item?.assignmentLocation?.value
                    ? item?.assignmentLocation?.value
                    : item?.assignmentLocation,
                }
              : {}),
          })),
        ],
      };

      delete dataToPost?.teamsDockside;
      delete dataToPost?.teamsStorage;
      let isHavingError: boolean = false;

      if (isHavingError) {
        console.log("error");
        return;
      }
      const res = await PlanningService.savePlanning(dataToPost);
      if (res?.status === HttpStatusCode.Ok) {
        handleSetOperationDefaultData(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const postAndRefreshData = () => {
    // handleClickOnSave()
    buttonSubmitRef.current?.click();
  };
  const handleDateFilter = (value: any) => {
    if (value) {
      setFilter((prev: any) => ({
        ...prev,
        teamsCreatedAt: dayjs(value).format("YYYY-MM-DD"),
      }));
    } else {
      setFilter((prev: any) => ({
        ...prev,
        teamsCreatedAt: dayjs().format("YYYY-MM-DD"),
      }));
    }
  };

  return (
    <div className={style.planning__wrapper}>
      <PlanningContext.Provider
        value={{
          allState,
          allTeams: allState?.teams,
          allDocksideTeam: allState?.teamsDockside,
          Form,
          errorMessage,
          handleSetTeamValue,
          handleDeleteTeamValue,
          onChangeHoldsHandler,
          onChangeTimeLine,
          postAndRefreshData,
          isDisableForm,
          onChangeInput,
        }}
      >
        <div className={style.planning}>
          <FormProvider
            Form={Form}
            form={form}
            debug
            onFinish={(values: any) => {
              handleClickOnSave(values);
            }}
            onFinishFailed={(err) => {
              console.log("err", err);
            }}
          >
            <div className="title_wrapper">
              <div className="d-flex gap-2 align-items-center justify-content-center">
                <label
                  htmlFor=""
                  style={{
                    // fontWeight: "bolder",
                    fontWeight: "600",
                    color: "gray",
                    paddingLeft: "2px",
                  }}
                >
                  {" "}
                  Date de planification{" "}
                </label>
                <DatePicker
                  placeholder=""
                  value={dayjs(filter.teamsCreatedAt, "YYYY-MM-DD")}
                  format={"DD/MM/YYYY"}
                  onChange={handleDateFilter}
                  // size="large"
                />
              </div>
            </div>
            {/* <div className="d-flex w-100 justify-content-center">
              <div className="d-flex flex-column">
                <label htmlFor=""> Date de Planification </label>
                <DatePicker
                  placeholder=""
                  value={dayjs(filter.teamsCreatedAt, "YYYY-MM-DD")}
                  format={"DD/MM/YYYY"}
                  onChange={handleDateFilter}
                  size="large"
                />
              </div>
            </div> */}
            <div className={style.planning__content}>
              {PlanningConstant.TEAMS_OPTION?.filter(
                (item: { value: string }) => {
                  // Exclude TEAM_ON_BOARD_ID if we are not in operation-sales
                  if (
                    operationType !== "sales" &&
                    (item.value === PlanningConstant.TEAM_ON_BOARD_ID ||
                      item.value === PlanningConstant.TEAM_STORAGE_ID)
                  ) {
                    return false;
                  }
                  return true;
                }
              ).map((item: { label: string; value: string }, key: number) => (
                <OnBoardTeam
                  key={key}
                  boardType={item}
                  allTeams={
                    item.value === PlanningConstant.TEAM_DOCKSIDE_ID
                      ? allState?.teamsDockside
                      : item.value === PlanningConstant.TEAM_STORAGE_ID
                      ? allState?.teamsStorage
                      : allState?.teams
                  }
                />
              ))}
              <div className="">
                <SimpleInput
                  Form={Form}
                  name={"noteTeam"}
                  label={"Note aux équipes"}
                  customInput={<TextArea />}
                />
              </div>
              <div className={style.planning__footer}>
                <button
                  className={style.planning__footer_button}
                  type="submit"
                  disabled={isDisableForm || isLoading}
                  ref={buttonSubmitRef}
                  style={{
                    cursor: isDisableForm ? "not-allowed" : "pointer",
                  }}
                >
                  {isLoading ? <Spinner /> : "Enregistrer"}
                </button>
              </div>
            </div>
          </FormProvider>
        </div>
      </PlanningContext.Provider>
    </div>
  );
};
